// Navigations

type Props = {
  className?: string;
};

export const Dashboard = ({ className }: Props) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="m2 6 4.437 3.17c.132.094.314.079.43-.036l2.267-2.268a.333.333 0 0 1 .43-.035L14 10M4 14h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2Z"
      />
    </svg>
  );
};

export const GrowthSettings = ({ className }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      d="M2 5.333h8m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm-4 5.334h8m-8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
    />
  </svg>
);

export const Scheduling = ({ className }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      d="M7.333 2.667H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 4.187 2 4.747 2 5.867V10.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 14 4.08 14 5.2 14h4.933c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V8.667m-4.666 2.666h-4M10 8.667H4.667m8.747-6.081a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828Z"
    />
  </svg>
);

export const Analytics = ({ className }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      d="M5.333 8.667v2.666m5.334-4v4M8 4.667v6.666M5.2 14h5.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C14 12.48 14 11.92 14 10.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C12.48 2 11.92 2 10.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 14 4.08 14 5.2 14Z"
    />
  </svg>
);

export const PerkTools = ({ className }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      d="M4.667 8 1.333 9.667l6.428 3.214c.088.043.132.065.178.074.04.008.082.008.122 0 .046-.009.09-.03.177-.074l6.429-3.214L11.333 8m-10-1.667L7.761 3.12a.725.725 0 0 1 .178-.074.333.333 0 0 1 .122 0c.046.009.09.03.177.074l6.429 3.214-6.429 3.214a.725.725 0 0 1-.177.075.333.333 0 0 1-.122 0 .725.725 0 0 1-.178-.075L1.333 6.333Z"
    />
  </svg>
);

export const OkGrowAI = ({ className }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      d="M3 14.667v-3.334m0-6.666V1.333M1.333 3h3.334M1.333 13h3.334m4-11L7.51 5.006c-.188.489-.282.733-.429.939a2 2 0 0 1-.47.47c-.206.147-.45.24-.94.429L2.668 8l3.006 1.156c.488.188.733.282.938.428a2 2 0 0 1 .471.471c.147.206.24.45.429.94L8.667 14l1.156-3.006c.188-.489.282-.733.428-.939.13-.182.289-.341.47-.47.207-.147.45-.24.94-.429L14.667 8 11.66 6.844c-.49-.188-.733-.282-.94-.428a1.999 1.999 0 0 1-.47-.471c-.146-.206-.24-.45-.428-.939L8.667 2Z"
    />
  </svg>
);

// Content Icons
export const FollowersGrowthIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99996 2.49996H13.5C14.9001 2.49996 15.6002 2.49996 16.1349 2.77244C16.6053 3.01213 16.9878 3.39458 17.2275 3.86498C17.5 4.39976 17.5 5.09983 17.5 6.49996V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.1349C16.9878 16.6053 16.6053 16.9878 16.1349 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.49996C5.09983 17.5 4.39976 17.5 3.86498 17.2275C3.39458 16.9878 3.01213 16.6053 2.77244 16.1349C2.49996 15.6002 2.49996 14.9001 2.49996 13.5V9.99996M6.66663 10.8333V14.1666M13.3333 9.16663V14.1666M9.99996 5.83329V14.1666M4.16663 6.66663V1.66663M1.66663 4.16663H6.66663"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GPTTrainingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 8.33329H2.5M17.5 10.4166V7.33329C17.5 5.93316 17.5 5.2331 17.2275 4.69832C16.9878 4.22791 16.6054 3.84546 16.135 3.60578C15.6002 3.33329 14.9001 3.33329 13.5 3.33329H6.5C5.09987 3.33329 4.3998 3.33329 3.86502 3.60578C3.39462 3.84546 3.01217 4.22791 2.77248 4.69832C2.5 5.2331 2.5 5.93316 2.5 7.33329V14.3333C2.5 15.7334 2.5 16.4335 2.77248 16.9683C3.01217 17.4387 3.39462 17.8211 3.86502 18.0608C4.3998 18.3333 5.09987 18.3333 6.5 18.3333H10M13.3333 1.66663V4.99996M6.66667 1.66663V4.99996M12.0833 15.8333L13.75 17.5L17.5 13.75"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ActivityFeedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.3334 10H15L12.5 17.5L7.50002 2.5L5.00002 10H1.66669"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TopFollowersInterestsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3333 2.8898C14.5681 3.50343 15.4166 4.77762 15.4166 6.25C15.4166 7.72238 14.5681 8.99657 13.3333 9.6102M15 13.972C16.2595 14.5419 17.3937 15.4708 18.3333 16.6667M1.66663 16.6667C3.2887 14.6021 5.49094 13.3333 7.91663 13.3333C10.3423 13.3333 12.5446 14.6021 14.1666 16.6667M11.6666 6.25C11.6666 8.32107 9.98769 10 7.91663 10C5.84556 10 4.16663 8.32107 4.16663 6.25C4.16663 4.17893 5.84556 2.5 7.91663 2.5C9.98769 2.5 11.6666 4.17893 11.6666 6.25Z"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TopTrafficSourcesIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_104_873)">
      <path
        d="M6.66669 10.8334V14.1667M13.3334 9.16675V14.1667M10 5.83341V14.1667M18.3334 10.0001C18.3334 14.6025 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6025 1.66669 10.0001C1.66669 5.39771 5.39765 1.66675 10 1.66675C14.6024 1.66675 18.3334 5.39771 18.3334 10.0001Z"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_104_873">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LocationOverviewIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.3334 10H15L12.5 17.5L7.50002 2.5L5.00002 10H1.66669"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

//
export const Support = ({ className }: Props) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_212_41116)">
      <path
        d="M7.0537 7.05375L4.10743 4.10748M4.10743 15.8926L7.05372 12.9463M12.9463 12.9463L15.8925 15.8926M15.8925 4.10744L12.9463 7.05373M18.3333 10C18.3333 14.6024 14.6024 18.3334 9.99999 18.3334C5.39762 18.3334 1.66666 14.6024 1.66666 10C1.66666 5.39765 5.39762 1.66669 9.99999 1.66669C14.6024 1.66669 18.3333 5.39765 18.3333 10ZM14.1667 10C14.1667 12.3012 12.3012 14.1667 9.99999 14.1667C7.6988 14.1667 5.83332 12.3012 5.83332 10C5.83332 7.69883 7.6988 5.83335 9.99999 5.83335C12.3012 5.83335 14.1667 7.69883 14.1667 10Z"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_212_41116">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Settings = ({ className }: Props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_212_41119)">
      <path
        d="M9.99999 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61931 11.3807 7.50002 9.99999 7.50002C8.61928 7.50002 7.49999 8.61931 7.49999 10C7.49999 11.3807 8.61928 12.5 9.99999 12.5Z"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6061 12.2727C15.5052 12.5012 15.4751 12.7547 15.5197 13.0005C15.5642 13.2462 15.6814 13.473 15.8561 13.6515L15.9015 13.697C16.0424 13.8377 16.1541 14.0048 16.2304 14.1887C16.3066 14.3727 16.3459 14.5698 16.3459 14.769C16.3459 14.9681 16.3066 15.1652 16.2304 15.3492C16.1541 15.5331 16.0424 15.7002 15.9015 15.8409C15.7608 15.9818 15.5937 16.0936 15.4097 16.1698C15.2258 16.2461 15.0287 16.2853 14.8295 16.2853C14.6304 16.2853 14.4333 16.2461 14.2493 16.1698C14.0654 16.0936 13.8983 15.9818 13.7576 15.8409L13.7121 15.7955C13.5336 15.6208 13.3068 15.5037 13.061 15.4591C12.8153 15.4145 12.5618 15.4446 12.3333 15.5455C12.1093 15.6415 11.9182 15.801 11.7836 16.0042C11.649 16.2075 11.5767 16.4456 11.5757 16.6894V16.8182C11.5757 17.22 11.4161 17.6054 11.132 17.8896C10.8478 18.1737 10.4624 18.3334 10.0606 18.3334C9.65875 18.3334 9.27337 18.1737 8.98922 17.8896C8.70508 17.6054 8.54544 17.22 8.54544 16.8182V16.75C8.53958 16.4993 8.45841 16.2561 8.3125 16.0521C8.16658 15.8481 7.96267 15.6927 7.72726 15.6061C7.49877 15.5052 7.2453 15.4752 6.99954 15.5197C6.75379 15.5643 6.52702 15.6814 6.34847 15.8561L6.30302 15.9015C6.1623 16.0424 5.9952 16.1542 5.81126 16.2304C5.62733 16.3067 5.43016 16.3459 5.23105 16.3459C5.03194 16.3459 4.83477 16.3067 4.65084 16.2304C4.4669 16.1542 4.2998 16.0424 4.15908 15.9015C4.01821 15.7608 3.90645 15.5937 3.8302 15.4098C3.75395 15.2258 3.71471 15.0287 3.71471 14.8296C3.71471 14.6305 3.75395 14.4333 3.8302 14.2494C3.90645 14.0654 4.01821 13.8983 4.15908 13.7576L4.20454 13.7121C4.37918 13.5336 4.49634 13.3068 4.5409 13.0611C4.58546 12.8153 4.55538 12.5619 4.45454 12.3334C4.3585 12.1093 4.19905 11.9182 3.9958 11.7836C3.79255 11.649 3.55437 11.5768 3.3106 11.5758H3.18181C2.77996 11.5758 2.39458 11.4161 2.11043 11.132C1.82629 10.8479 1.66666 10.4625 1.66666 10.0606C1.66666 9.65878 1.82629 9.2734 2.11043 8.98925C2.39458 8.70511 2.77996 8.54548 3.18181 8.54548H3.24999C3.50074 8.53961 3.74393 8.45844 3.94794 8.31253C4.15195 8.16661 4.30735 7.9627 4.39393 7.72729C4.49477 7.4988 4.52486 7.24533 4.4803 6.99957C4.43574 6.75382 4.31858 6.52705 4.14393 6.34851L4.09847 6.30305C3.9576 6.16233 3.84585 5.99523 3.7696 5.81129C3.69335 5.62736 3.6541 5.4302 3.6541 5.23108C3.6541 5.03197 3.69335 4.83481 3.7696 4.65087C3.84585 4.46693 3.9576 4.29983 4.09847 4.15911C4.23919 4.01824 4.4063 3.90648 4.59023 3.83023C4.77417 3.75398 4.97133 3.71474 5.17044 3.71474C5.36956 3.71474 5.56672 3.75398 5.75066 3.83023C5.93459 3.90648 6.1017 4.01824 6.24241 4.15911L6.28787 4.20457C6.46641 4.37922 6.69318 4.49637 6.93894 4.54093C7.18469 4.58549 7.43816 4.55541 7.66666 4.45457H7.72726C7.95133 4.35853 8.14243 4.19908 8.27703 3.99583C8.41163 3.79258 8.48387 3.5544 8.48484 3.31063V3.18184C8.48484 2.78 8.64447 2.39461 8.92862 2.11046C9.21276 1.82632 9.59815 1.66669 9.99999 1.66669C10.4018 1.66669 10.7872 1.82632 11.0714 2.11046C11.3555 2.39461 11.5151 2.78 11.5151 3.18184V3.25002C11.5161 3.4938 11.5883 3.73197 11.723 3.93522C11.8576 4.13847 12.0487 4.29793 12.2727 4.39396C12.5012 4.4948 12.7547 4.52489 13.0004 4.48033C13.2462 4.43577 13.473 4.31861 13.6515 4.14396L13.697 4.09851C13.8377 3.95763 14.0048 3.84588 14.1887 3.76963C14.3727 3.69338 14.5698 3.65413 14.7689 3.65413C14.968 3.65413 15.1652 3.69338 15.3491 3.76963C15.5331 3.84588 15.7002 3.95763 15.8409 4.09851C15.9818 4.23922 16.0935 4.40633 16.1698 4.59026C16.246 4.7742 16.2853 4.97136 16.2853 5.17048C16.2853 5.36959 16.246 5.56675 16.1698 5.75069C16.0935 5.93462 15.9818 6.10173 15.8409 6.24244L15.7954 6.2879C15.6208 6.46644 15.5036 6.69321 15.4591 6.93897C15.4145 7.18472 15.4446 7.43819 15.5454 7.66669V7.72729C15.6415 7.95136 15.8009 8.14246 16.0042 8.27706C16.2074 8.41166 16.4456 8.4839 16.6894 8.48487H16.8182C17.22 8.48487 17.6054 8.6445 17.8895 8.92865C18.1737 9.21279 18.3333 9.59818 18.3333 10C18.3333 10.4019 18.1737 10.7872 17.8895 11.0714C17.6054 11.3555 17.22 11.5152 16.8182 11.5152H16.75C16.5062 11.5161 16.268 11.5884 16.0648 11.723C15.8615 11.8576 15.7021 12.0487 15.6061 12.2727Z"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_212_41119">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MenuIcon = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M2 8h8M2 4h12M2 12h12" />
  </svg>
);

export const UpgradePlanIcon = ({ className }: Props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_132_15950)">
      <path
        d="M10.6667 8L8.00004 5.33333M8.00004 5.33333L5.33337 8M8.00004 5.33333V10.6667M14.6667 8C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8C1.33337 4.3181 4.31814 1.33333 8.00004 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z"
        stroke="url(#paint0_linear_132_15950)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_132_15950"
        x1="8.00004"
        y1="1.33333"
        x2="8.00004"
        y2="14.6667"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset="1" stopColor="#999999" />
      </linearGradient>
      <clipPath id="clip0_132_15950">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UpgradePlanSolidIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_349_22)">
      <path
        d="M11.4167 8.00004L8.75004 5.33337M8.75004 5.33337L6.08337 8.00004M8.75004 5.33337V10.6667M15.4167 8.00004C15.4167 11.6819 12.4319 14.6667 8.75004 14.6667C5.06814 14.6667 2.08337 11.6819 2.08337 8.00004C2.08337 4.31814 5.06814 1.33337 8.75004 1.33337C12.4319 1.33337 15.4167 4.31814 15.4167 8.00004Z"
        stroke="#0F0F0F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_349_22">
        <rect width="16" height="16" fill="white" transform="translate(0.75)" />
      </clipPath>
    </defs>
  </svg>
);

export const PauseIcon = ({ className, color = "white" }: Props & { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#clip0_238_4649)">
      <path
        d="M6.33337 10V6M9.66671 10V6M14.6667 8C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8C1.33337 4.3181 4.31814 1.33333 8.00004 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_238_4649">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ChevronUpDown = ({ className }: Props) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.6665 9.99996L7.99984 13.3333L11.3332 9.99996M4.6665 5.99996L7.99984 2.66663L11.3332 5.99996"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_104_265)">
      <path
        d="M9.99996 18.3333C14.6023 18.3333 18.3333 14.6023 18.3333 9.99996C18.3333 5.39759 14.6023 1.66663 9.99996 1.66663C5.39759 1.66663 1.66663 5.39759 1.66663 9.99996C1.66663 14.6023 5.39759 18.3333 9.99996 18.3333Z"
        fill="#D4D4D4"
      />
      <path
        d="M9.99996 13.3333V9.99996M9.99996 6.66663H10.0083M18.3333 9.99996C18.3333 14.6023 14.6023 18.3333 9.99996 18.3333C5.39759 18.3333 1.66663 14.6023 1.66663 9.99996C1.66663 5.39759 5.39759 1.66663 9.99996 1.66663C14.6023 1.66663 18.3333 5.39759 18.3333 9.99996Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_104_265">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HeartIcon = ({ className }: Props) => (
  <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_104_335)">
      <path
        d="M12 14.6667L14.6666 17.3333L20.6666 11.3333M15.9908 6.84775C13.325 3.7312 8.87962 2.89286 5.53955 5.74668C2.19948 8.60051 1.72925 13.372 4.35222 16.7472C6.33341 19.2966 11.9617 24.4146 14.5973 26.7665C15.0818 27.1989 15.3241 27.415 15.6077 27.5001C15.854 27.574 16.1277 27.574 16.3739 27.5001C16.6576 27.415 16.8998 27.1989 17.3844 26.7665C20.02 24.4146 25.6482 19.2966 27.6294 16.7472C30.2524 13.372 29.8396 8.57049 26.4421 5.74668C23.0446 2.92288 18.6566 3.7312 15.9908 6.84775Z"
        stroke="#F5F5F5"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_104_335"
        x="1.4165"
        y="2.74756"
        width="29.1666"
        height="28.0579"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.733333 0 0 0 0 0.72549 0 0 0 0 0.752941 0 0 0 1 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_104_335" />
      </filter>
    </defs>
  </svg>
);

export const LineChartCircle = ({ className }: Props) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_497_7647)">
      <path
        d="M15 8.33317L12.138 11.1951C11.973 11.3601 11.8905 11.4426 11.7954 11.4735C11.7117 11.5007 11.6216 11.5007 11.5379 11.4735C11.4427 11.4426 11.3602 11.3601 11.1952 11.1951L8.8047 8.80458C8.63969 8.63957 8.55719 8.55707 8.46205 8.52615C8.37837 8.49896 8.28822 8.49896 8.20454 8.52615C8.1094 8.55707 8.0269 8.63957 7.86189 8.80458L4.99996 11.6665M18.3333 9.99984C18.3333 14.6022 14.6023 18.3332 9.99996 18.3332C5.39759 18.3332 1.66663 14.6022 1.66663 9.99984C1.66663 5.39746 5.39759 1.6665 9.99996 1.6665C14.6023 1.6665 18.3333 5.39746 18.3333 9.99984Z"
        stroke="#A3A3A3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_497_7647">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Calendar = ({ className }: Props) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 8.33317H2.5M13.3333 1.6665V4.99984M6.66667 1.6665V4.99984M8.75 11.6665L10 10.8332V14.9998M8.95833 14.9998H11.0417M6.5 18.3332H13.5C14.9001 18.3332 15.6002 18.3332 16.135 18.0607C16.6054 17.821 16.9878 17.4386 17.2275 16.9681C17.5 16.4334 17.5 15.7333 17.5 14.3332V7.33317C17.5 5.93304 17.5 5.23297 17.2275 4.69819C16.9878 4.22779 16.6054 3.84534 16.135 3.60565C15.6002 3.33317 14.9001 3.33317 13.5 3.33317H6.5C5.09987 3.33317 4.3998 3.33317 3.86502 3.60565C3.39462 3.84534 3.01217 4.22779 2.77248 4.69819C2.5 5.23297 2.5 5.93304 2.5 7.33317V14.3332C2.5 15.7333 2.5 16.4334 2.77248 16.9681C3.01217 17.4386 3.39462 17.821 3.86502 18.0607C4.3998 18.3332 5.09987 18.3332 6.5 18.3332Z"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Like = ({ className }: Props) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_500_12892)">
      <path
        d="M4.66659 14.6663V7.33301M1.33325 8.66634V13.333C1.33325 14.0694 1.93021 14.6663 2.66659 14.6663H11.6174C12.6046 14.6663 13.4441 13.9461 13.5942 12.9705L14.3121 8.30379C14.4985 7.09227 13.5611 5.99967 12.3354 5.99967H9.99992C9.63173 5.99967 9.33325 5.7012 9.33325 5.33301V2.9769C9.33325 2.069 8.59726 1.33301 7.68936 1.33301C7.47281 1.33301 7.27657 1.46054 7.18862 1.65842L4.84254 6.9371C4.73554 7.17785 4.4968 7.33301 4.23334 7.33301H2.66659C1.93021 7.33301 1.33325 7.92996 1.33325 8.66634Z"
        stroke="#AB9FF9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_500_12892">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CommentMessage = ({ className }: Props) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.33316 6.33333H7.99983M5.33316 8.66667H9.99983M8.33316 13.3333C11.4628 13.3333 13.9998 10.7963 13.9998 7.66667C13.9998 4.53705 11.4628 2 8.33316 2C5.20355 2 2.6665 4.53705 2.6665 7.66667C2.6665 8.3 2.7704 8.90906 2.96208 9.47774C3.03421 9.69175 3.07028 9.79875 3.07678 9.88095C3.08321 9.96213 3.07835 10.019 3.05827 10.098C3.03793 10.1779 2.99303 10.261 2.90323 10.4272L1.81279 12.4456C1.65725 12.7335 1.57948 12.8774 1.59688 12.9885C1.61204 13.0853 1.669 13.1705 1.75261 13.2215C1.84862 13.2801 2.01136 13.2632 2.33686 13.2296L5.75087 12.8767C5.85426 12.866 5.90595 12.8606 5.95307 12.8624C5.99941 12.8642 6.03213 12.8686 6.07732 12.879C6.12327 12.8896 6.18104 12.9118 6.2966 12.9564C6.92864 13.1999 7.61531 13.3333 8.33316 13.3333Z"
      stroke="#99D6B2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AlertCircle = ({ className }: Props) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_500_13134)">
      <path
        d="M7.99992 5.3335V8.00016M7.99992 10.6668H8.00659M14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016Z"
        stroke="#D8211C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_500_13134">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Speedometer = ({ className }: Props) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1222_15400)">
      <path
        d="M4.16663 10.0003C4.16663 6.77866 6.7783 4.16699 9.99996 4.16699M13.7499 6.25033L9.99988 10.0003M18.3333 10.0003C18.3333 14.6027 14.6023 18.3337 9.99996 18.3337C5.39759 18.3337 1.66663 14.6027 1.66663 10.0003C1.66663 5.39795 5.39759 1.66699 9.99996 1.66699C14.6023 1.66699 18.3333 5.39795 18.3333 10.0003ZM10.8333 10.0003C10.8333 10.4606 10.4602 10.8337 9.99996 10.8337C9.53972 10.8337 9.16663 10.4606 9.16663 10.0003C9.16663 9.54009 9.53972 9.16699 9.99996 9.16699C10.4602 9.16699 10.8333 9.54009 10.8333 10.0003Z"
        stroke="#2C5152"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1222_15400">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Targeting = ({ className }: Props) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1223_16807)">
      <path
        d="M10 18.3337C14.6024 18.3337 18.3333 14.6027 18.3333 10.0003C18.3333 5.39795 14.6024 1.66699 10 1.66699C5.39763 1.66699 1.66667 5.39795 1.66667 10.0003C1.66667 14.6027 5.39763 18.3337 10 18.3337Z"
        stroke="#0F0F0F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15.0003C12.7614 15.0003 15 12.7617 15 10.0003C15 7.2389 12.7614 5.00033 10 5.00033C7.23858 5.00033 5.00001 7.2389 5.00001 10.0003C5.00001 12.7617 7.23858 15.0003 10 15.0003Z"
        stroke="#0F0F0F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.667C10.9205 11.667 11.6667 10.9208 11.6667 10.0003C11.6667 9.07985 10.9205 8.33366 10 8.33366C9.07953 8.33366 8.33334 9.07985 8.33334 10.0003C8.33334 10.9208 9.07953 11.667 10 11.667Z"
        stroke="#0F0F0F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1223_16807">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Tiktok = ({ className }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <path
      fill="#737373"
      d="M12.88 3.708c-.1-.052-.199-.11-.294-.172a4.154 4.154 0 0 1-.759-.644 3.577 3.577 0 0 1-.854-1.764h.003C10.91.747 10.937.5 10.942.5H8.365v9.962c0 .134 0 .266-.005.396 0 .017-.002.032-.003.05l-.001.021v.006a2.188 2.188 0 0 1-1.101 1.736 2.15 2.15 0 0 1-1.066.282 2.18 2.18 0 0 1-2.173-2.188 2.18 2.18 0 0 1 2.173-2.188c.227 0 .453.036.67.106L6.86 6.06a4.786 4.786 0 0 0-3.687 1.08A5.056 5.056 0 0 0 2.07 8.5c-.11.187-.52.94-.57 2.163-.03.694.178 1.413.277 1.71v.007c.063.175.305.772.7 1.275.318.404.694.759 1.116 1.053v-.006l.006.006c1.247.848 2.63.792 2.63.792.24-.01 1.041 0 1.952-.432 1.01-.478 1.585-1.19 1.585-1.19.367-.427.66-.912.864-1.436a5.375 5.375 0 0 0 .31-1.642V5.515l.448.294s.6.385 1.535.635c.672.178 1.576.216 1.576.216V4.102c-.317.035-.96-.065-1.62-.394Z"
    />
  </svg>
);

export const Hash = () => (
  <svg className="size-4 shrink-0" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.33334 2L4.33334 14M11.6667 2L9.66666 14M13.6667 5.33333H2.33335M13 10.6667H1.66669"
      stroke="#737373"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MaleSymbol = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15ZM12 15V19M12 19V21M12 19H10M12 19H14"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FemaleSymbol = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.2323 9.74707C13.1474 8.66733 11.6516 8 10 8C6.68629 8 4 10.6863 4 14C4 17.3137 6.68629 20 10 20C13.3137 20 16 17.3137 16 14C16 12.3379 15.3242 10.8337 14.2323 9.74707ZM14.2323 9.74707L20 4M20 4H16M20 4V8"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserCircle = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1222_15447)">
      <path
        d="M4.43021 16.199C4.93714 15.0047 6.12073 14.167 7.49996 14.167H12.5C13.8792 14.167 15.0628 15.0047 15.5697 16.199M13.3333 7.91699C13.3333 9.75794 11.8409 11.2503 9.99996 11.2503C8.15901 11.2503 6.66663 9.75794 6.66663 7.91699C6.66663 6.07604 8.15901 4.58366 9.99996 4.58366C11.8409 4.58366 13.3333 6.07604 13.3333 7.91699ZM18.3333 10.0003C18.3333 14.6027 14.6023 18.3337 9.99996 18.3337C5.39759 18.3337 1.66663 14.6027 1.66663 10.0003C1.66663 5.39795 5.39759 1.66699 9.99996 1.66699C14.6023 1.66699 18.3333 5.39795 18.3333 10.0003Z"
        stroke="#522524"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1222_15447">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TranslateIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.16663 6.66699L8.33329 10.8337M3.33329 11.667L8.33329 6.66699L9.99996 4.16699M1.66663 4.16699H11.6666M5.83329 1.66699H6.66663M10.7608 14.167H16.7391M10.7608 14.167L9.16663 17.5003M10.7608 14.167L13.1485 9.17451C13.3409 8.77222 13.4371 8.57107 13.5688 8.50751C13.6832 8.45223 13.8167 8.45223 13.9311 8.50751C14.0628 8.57107 14.159 8.77222 14.3514 9.17451L16.7391 14.167M16.7391 14.167L18.3333 17.5003"
      stroke="#383452"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Globe = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1222_13015)">
      <path
        d="M2.05057 4.98822L4.90927 7.03011C5.05802 7.13636 5.1324 7.18948 5.21024 7.20173C5.27873 7.2125 5.34887 7.20164 5.41091 7.17067C5.48141 7.13548 5.53625 7.06236 5.64593 6.91611L6.24999 6.11069C6.28101 6.06933 6.29652 6.04865 6.31475 6.03082C6.33093 6.01498 6.34869 6.00083 6.36774 5.98859C6.3892 5.97481 6.41282 5.96431 6.46006 5.94332L9.03912 4.79707C9.14603 4.74955 9.19948 4.72579 9.23979 4.68869C9.27544 4.65587 9.30351 4.61568 9.32204 4.5709C9.34299 4.52028 9.34688 4.46191 9.35466 4.34518L9.5435 1.51261M8.99992 8.99967L10.7439 9.74711C10.9463 9.83383 11.0474 9.87718 11.101 9.94921C11.1481 10.0124 11.1712 10.0902 11.1663 10.1688C11.1608 10.2584 11.0997 10.35 10.9776 10.5332L10.1582 11.7622C10.1004 11.849 10.0714 11.8924 10.0332 11.9239C9.99932 11.9517 9.96032 11.9726 9.91839 11.9853C9.87102 11.9997 9.81884 11.9997 9.71449 11.9997H8.38432C8.24609 11.9997 8.17698 11.9997 8.11817 11.9766C8.06624 11.9561 8.02027 11.923 7.98447 11.8802C7.94393 11.8317 7.92207 11.7661 7.87836 11.635L7.40311 10.2093C7.37733 10.1319 7.36444 10.0932 7.36104 10.0539C7.35804 10.0191 7.36053 9.98397 7.36844 9.9499C7.37736 9.91147 7.39559 9.87501 7.43205 9.80208L7.79306 9.08007C7.86641 8.93337 7.90308 8.86002 7.95957 8.81448C8.00935 8.77435 8.06962 8.74938 8.1332 8.74256C8.20535 8.73482 8.28314 8.76075 8.43874 8.81261L8.99992 8.99967ZM14.6666 7.99967C14.6666 11.6816 11.6818 14.6663 7.99992 14.6663C4.31802 14.6663 1.33325 11.6816 1.33325 7.99967C1.33325 4.31778 4.31802 1.33301 7.99992 1.33301C11.6818 1.33301 14.6666 4.31778 14.6666 7.99967Z"
        stroke="#6ACBCC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1222_13015">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LocationMark = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1222_16533)">
      <path
        d="M4.16675 11.9056C2.62395 12.5862 1.66675 13.5346 1.66675 14.5837C1.66675 16.6547 5.39771 18.3337 10.0001 18.3337C14.6025 18.3337 18.3334 16.6547 18.3334 14.5837C18.3334 13.5346 17.3762 12.5862 15.8334 11.9056M15.0001 6.66699C15.0001 10.0534 11.2501 11.667 10.0001 14.167C8.75008 11.667 5.00008 10.0534 5.00008 6.66699C5.00008 3.90557 7.23866 1.66699 10.0001 1.66699C12.7615 1.66699 15.0001 3.90557 15.0001 6.66699ZM10.8334 6.66699C10.8334 7.12723 10.4603 7.50033 10.0001 7.50033C9.53984 7.50033 9.16675 7.12723 9.16675 6.66699C9.16675 6.20676 9.53984 5.83366 10.0001 5.83366C10.4603 5.83366 10.8334 6.20676 10.8334 6.66699Z"
        stroke="#664514"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1222_16533">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HeartRounded = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.426 2.5C16.3612 2.5 18.3334 5.29375 18.3334 7.9C18.3334 13.1781 10.1482 17.5 10.0001 17.5C9.85193 17.5 1.66675 13.1781 1.66675 7.9C1.66675 5.29375 3.63897 2.5 6.57416 2.5C8.25934 2.5 9.36119 3.35312 10.0001 4.10312C10.639 3.35312 11.7408 2.5 13.426 2.5Z"
      stroke="#215235"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
